import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterNeighborhoods'
})
export class FilterNeighborhoodsPipe implements PipeTransform {
  transform(value: any, filterString: string): any {
    if (filterString && filterString.length < 2) {
      return;
    }
    if (!value) {
      return;
    }
    if (value.length === 0) {
      return;
    }
    const resultArray = [];
    for (const item of value) {
      if (item.title.includes(filterString)) {
        resultArray.push(item);
      }
    }
    return resultArray;
  }
}
